import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface ActionZoneProps {
  title: string;
  color: string;
  children: ReactNode;
  isEmpty: boolean;
  isLoading: boolean;
  showActionButton?: boolean;
  onActionClick?: () => void;
}

export function ActionZoneComponent( { title, color, children, isEmpty, isLoading }: ActionZoneProps ) {
  const { t } = useTranslation();

  const borderColor = color;
  const bgColor = color;

  return (
    <div
      className='flex flex-col w-full p-6 rounded-lg border-2'
      style={ { borderColor: borderColor, backgroundColor: `${bgColor}10` } }
    >
      <div
        className='flex items-center justify-between p-4 -m-6 mb-6 rounded-t-md border-b-2'
        style={ { backgroundColor: `${bgColor}20`, borderColor: bgColor } }
      >
        <h3 className='text-lg font-bold text-gray-800'>
          { title }
        </h3>
      </div>

      <div className='flex flex-col gap-3'>
        {
          isLoading ?
            <div className='flex w-full py-8 items-center justify-center text-gray-600'>
              { t( 'loading' ) }
            </div>
            :
            isEmpty ?
              <div className='flex w-full py-8 items-center justify-center text-gray-600'>
                { t( 'no_actions_recorded' ) }
              </div>
              :
              children
        }
      </div>
    </div>
  );
}
